import React, { useState, useEffect } from 'react';
import PlanServices from '../../../services/PlanServices';
import UserServices from '../../../services/UserServices';
import {Link} from 'react-router-dom'
function AddSubscription() {
  const [userDetails, setUserDetails] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [emailOrPhone, setEmailOrPhone] = useState('');
  const [error, setError] = useState(null);
// Debounce state to manage the delay before making API request
const [debouncedEmailOrPhone, setDebouncedEmailOrPhone] = useState('');

  // Fetch all plans when the component mounts
  useEffect(() => {
    PlanServices.getAllPlan().then(response => {
      setPlans(response);
     
    }).catch(error => {
      console.error("There was an error fetching the plans!", error);
    })
  }, []);

  // Fetch user details when email or phone is entered
//   useEffect(() => {
//     if (emailOrPhone) {
//       UserServices.getSingleUser(emailOrPhone)
//         .then(response => {
//             console.log(response)
//           setUserDetails(response.data);
//         })
//         .catch(error => {
//           console.error("There was an error fetching the user details!", error);
//         });
//     }
//   }, [emailOrPhone]);
 // Debounce the emailOrPhone input
 useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedEmailOrPhone(emailOrPhone);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [emailOrPhone]);

  // Fetch user details when the debounced value changes
  useEffect(() => {
    if (debouncedEmailOrPhone) {
      UserServices.getSingleUser(debouncedEmailOrPhone)
        .then(response => {
          setUserDetails(response[0]);
        })
        .catch(error => {
          console.error("There was an error fetching the user details!", error);
        });
    }
  }, [debouncedEmailOrPhone]);
  // Fetch plan details when a plan is selected from the dropdown
  useEffect(() => {
    if (selectedPlan) {
      const plan = plans.find(p => p._id === selectedPlan);
      if (plan) {
        setSelectedPlan(plan);
      }
    }
  }, [selectedPlan, plans]);

  const handleSubmit = (e) => {
    e.preventDefault();
     PlanServices.createSubscriptionList({
         "userId": userDetails._id,
         "planId": selectedPlan._id
     }).then(response => {
         console.log(response);
         alert('Subscription Added Successfully');
     }).catch(error => {
         console.error("There was an error fetching the plans!", error);
         alert('Failed to add subscription details');
     })
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Subscription add</h2>
        <div className="container-box-top-header-right">
          <Link className="list-banner-btn" to="/admin/subscription">Subscription List</Link>
        </div>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-field">
                    <label>User Email/Phone</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={emailOrPhone}
                      onChange={(e) => setEmailOrPhone(e.target.value)}
                      placeholder="Enter email or phone number" 
                    />
                  </div>
                </div>
                {userDetails && (
                  <>
                    <div className="col-md-6">
                      <div className="input-field">
                        <label>User Name</label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={userDetails.name} 
                          readOnly 
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-field">
                        <label>Mobile No.</label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={userDetails.mobileNo} 
                          readOnly 
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Package</label>
                    <select 
                      className="form-control" 
                      value={selectedPlan._id}
                      onChange={(e) => setSelectedPlan(e.target.value)}
                    >
                      <option value="">Select a package</option>
                      {plans.map(plan => (
                        <option key={plan._id} value={plan._id}>
                          {plan.name} - ₹{plan.price}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {selectedPlan && (
                  <>
                    <div className="col-md-6">
                      <div className="input-field">
                        <label>Amount</label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={selectedPlan.price} 
                          readOnly 
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="input-field">
                        <label>Start date</label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={new Date().toLocaleDateString()} 
                          readOnly 
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="input-field">
                        <label>End Date</label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={new Date(new Date().setDate(new Date().getDate() + 40)).toLocaleDateString()} 
                          readOnly 
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Transaction ID</label>
                    <input type="text" name="transactionId" className="form-control" placeholder="Enter Transaction ID" />
                  </div>
                  <div className="input-field">
                    <div className="d-flex align-items-center">
                      <span className="me-2"><input type="checkbox" /></span>
                      <label>Link will be sent to user containing username & temporary password.</label>
                    </div>
                  </div>
                </div>
              </div>
              <button className="submit-green-btn" type="submit">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddSubscription;
